import axios from 'axios'
import jwtDefaultConfig from './jwtDefaultConfig'
import { getTimestamp } from '../../../utility/formats/formattedDate'

const REQUEST_TIMEOUT_MS = 30000
const LAST_AUTH_FAILURE_KEY = 'lastAuthFailure'

export default class JwtService {
  // ** jwtConfig <= Will be used by this service
  jwtConfig = { ...jwtDefaultConfig }

  // ** For Refreshing Token
  isAlreadyFetchingAccessToken = false

  // ** For Refreshing Token
  subscribers = []

  constructor(jwtOverrideConfig) {
    this.jwtConfig = { ...this.jwtConfig, ...jwtOverrideConfig }

    // ** Sin timeout axios espera indefinidamente: con el backend lento las peticiones se acumulan
    // y el usuario recarga. Un `timeout` propio de la petición sigue mandando sobre este valor
    axios.defaults.timeout = REQUEST_TIMEOUT_MS

    // ** Otra pestaña cerró la sesión (logout o 401): esta quedaría con el estado de Redux viejo
    window.addEventListener('storage', event => {
      if (event.key === 'userData' && event.newValue === null && event.oldValue !== null) {
        window.location.reload()
      }
    })

    // ** Request Interceptor
    axios.interceptors.request.use(
      config => {
        // ** Get token from localStorage
        const accessToken = this.getToken()

        // ** If token is present add it to request's Authorization Header
        if (accessToken) {
          // ** eslint-disable-next-line no-param-reassign
          config.headers.Authorization = `${this.jwtConfig.tokenType} ${accessToken}`
        }
        return config
      },
      error => Promise.reject(error)
    )

    // ** Add request/response interceptor
    axios.interceptors.response.use(
      response => response,
      error => {
        // ** const { config, response: { status } } = error
        const { response } = error
        // const originalRequest = config

        // ** if (status === 401) {
        if (response && response.status === 401 && this.isSessionRequest(error.config)) {
          this.expireSession(error.config)
          // if (!this.isAlreadyFetchingAccessToken) {
          //   this.isAlreadyFetchingAccessToken = true
          //   this.refreshToken().then(r => {
          //     this.isAlreadyFetchingAccessToken = false
          //
          //     // ** Update accessToken in localStorage
          //     this.setToken(r.data.accessToken)
          //     this.setRefreshToken(r.data.refreshToken)
          //
          //     this.onAccessTokenFetched(r.data.accessToken)
          //   })
          // }
          // const retryOriginalRequest = new Promise(resolve => {
          //   this.addSubscriber(accessToken => {
          //     // ** Make sure to assign accessToken according to your response.
          //     // ** Check: https://pixinvent.ticksy.com/ticket/2413870
          //     // ** Change Authorization header
          //     originalRequest.headers.Authorization = `${this.jwtConfig.tokenType} ${accessToken}`
          //     resolve(this.axios(originalRequest))
          //   })
          // })
          // return retryOriginalRequest
        }
        return Promise.reject(error)
      }
    )
  }

  // ** El login devuelve 401 con credenciales malas y una petición sin token no tiene sesión que perder.
  // Tampoco la que salió con un token anterior: con el backend lento, el 401 de una sesión vieja
  // llega después de un login nuevo y borraba el token recién guardado
  isSessionRequest(config) {
    const token = this.getToken()

    return !!token &&
      config?.url !== this.jwtConfig.loginEndpoint &&
      config?.headers?.Authorization === `${this.jwtConfig.tokenType} ${token}`
  }

  // ** Deja registrado qué petición provocó el cierre: un 401 suelto del backend es indistinguible
  // de un token vencido si no se sabe cuál endpoint lo devolvió
  expireSession(config) {
    const failure = {
      url: config?.url,
      method: config?.method,
      at: getTimestamp()
    }

    console.warn('[auth] 401 recibido, se cierra la sesión', failure)
    try {
      localStorage.setItem(LAST_AUTH_FAILURE_KEY, JSON.stringify(failure))
    } catch {
      // ** localStorage lleno o bloqueado: el console.warn ya dejó el dato
    }
    this.removeToken()
  }

  onAccessTokenFetched(accessToken) {
    this.subscribers = this.subscribers.filter(callback => callback(accessToken))
  }

  addSubscriber(callback) {
    this.subscribers.push(callback)
  }

  getToken() {
    return localStorage.getItem(this.jwtConfig.storageTokenKeyName)
  }

  getRefreshToken() {
    return localStorage.getItem(this.jwtConfig.storageRefreshTokenKeyName)
  }

  setToken(value) {
    localStorage.setItem(this.jwtConfig.storageTokenKeyName, value)
  }

  removeToken() {
    localStorage.removeItem('userData')
    localStorage.removeItem(this.jwtConfig.storageTokenKeyName)
  }

  setRefreshToken(value) {
    localStorage.setItem(this.jwtConfig.storageRefreshTokenKeyName, value)
  }

  login(...args) {
    return axios.post(this.jwtConfig.loginEndpoint, ...args)
  }

  register(...args) {
    return axios.post(this.jwtConfig.registerEndpoint, ...args)
  }

  refreshToken() {
    return axios.post(this.jwtConfig.refreshEndpoint, {
      refreshToken: this.getRefreshToken()
    })
  }
}
